import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDateTime } from '../utils/date.utils';

/** Date and time without seconds; app `LOCALE_ID` (e.g. en-AU); 12-hour clock (see `formatDateTime` in date.utils). */
@Pipe({
  name: 'crowdctrlFormatDateTime',
  standalone: true,
})
export class CrowdctrlFormatDateTimePipe implements PipeTransform {
  private readonly localeId = inject(LOCALE_ID);

  transform(value: Date | string | undefined | null): string {
    return formatDateTime(value, this.localeId);
  }
}
